import * as Cesium from "cesium"
import "./dist/index.css"
import getConf from "../services/corridorConf"
import "../css/Widgets/widgets.css"
import "../css/Widgets/lighter.css"
import "../css/main.css"
import instantiateViewer from "../services/viewerFuncs/instantiateViewer";
import loadTileSet from "../services/viewerFuncs/tileBuilder"
window.CESIUM_BASE_URL = '/';

let availSets, viewer, dateStart
let dragStartX = 0;

const ThreeDViewComponent = (dataset, firstLoad, leftDate, rightDate, viewType,  token) => {

    function mouseUp() {
        window.removeEventListener("mousemove", sliderMove, true);
    }

    function mouseDown(e) {
        const slider = document.getElementById("swipeSlide");
        dragStartX = e.clientX - slider.offsetLeft;
        window.addEventListener("mousemove", sliderMove, true);
    }

    function sliderMove(e) {
        const slider = document.getElementById("swipeSlide");
        const splitPosition =
            (e.clientX - dragStartX) / slider.parentElement.offsetWidth;
        slider.style.left = `${100.0 * splitPosition}%`;
        viewer.scene.splitPosition = splitPosition;
    }

    function viewSetup() {
        viewer.scene.primitives.removeAll()
        viewer.scene.globe.baseColor = Cesium.Color.BLACK;

    }

    function cameraPosLog(){
        viewer.camera.moveEnd.addEventListener(function(camera){
            console.log(
        `"initLat": ${Cesium.Math.toDegrees(viewer.camera.positionCartographic.latitude)},
        "initLong": ${Cesium.Math.toDegrees(viewer.camera.positionCartographic.longitude)},
        "initHeight": ${viewer.camera.positionCartographic.height},
        "pitch": ${Cesium.Math.toDegrees(viewer.camera.pitch)},
        "heading": ${Cesium.Math.toDegrees(viewer.camera.heading)}`)
        })
    }

    function viewerFlyTo(datasetConf){
        viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(datasetConf.initLong, datasetConf.initLat, datasetConf.initHeight),
            orientation: {
                heading: Cesium.Math.toRadians(datasetConf.heading),
                pitch: Cesium.Math.toRadians(datasetConf.pitch),
            }
        })
    }

    function homeButtonHijack(datasetConf){
        viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
            function (e) {
                e.cancel = true;
                //Where do you want to fly
                viewerFlyTo(datasetConf)
            }
        );
    }

    function splitViewer(){
        const slider = document.getElementById("swipeSlide");
        viewer.scene.splitPosition =
            slider.offsetLeft / slider.parentElement.offsetWidth;

        document
            .getElementById("swipeSlide")
            .addEventListener("mousedown", mouseDown, false);
        window.addEventListener("mouseup", mouseUp, false);
    }
    function debounce(func){
        let timer;
        return function(event){
            if(timer) clearTimeout(timer);
            timer = setTimeout(func,100,event);
        };
    }

    window.addEventListener("resize",debounce(function(e){
        viewer.canvas.height =  (window.innerHeight * .70)
    }));


    const createViewer = async(dataset, firstLoad, leftDate, rightDate, viewType, availDates) => {

        let datasetConf = await getConf(dataset)
        console.log(`dataset conf at create viewer: ${JSON.stringify(datasetConf)}`)
        if (leftDate === undefined){
            dateStart = availDates[0]
        } else {
            dateStart = leftDate
        }
        let viewerExists = document.body.contains(document.getElementsByClassName("cesium-viewer")[0])
        if (viewer === undefined || viewerExists === false){
            viewer = await instantiateViewer(datasetConf)
        }
        if (viewer.homeButton) {
            homeButtonHijack(datasetConf)
        }
        let canvas = viewer.canvas;
        viewSetup(datasetConf)
        cameraPosLog()
        if (viewType === '2') {
            loadTileSet(dataset, leftDate, token, viewer, "leftTileSet", Cesium.SplitDirection.LEFT)
            loadTileSet(dataset, rightDate, token, viewer, "rightTileSet", Cesium.SplitDirection.RIGHT)
            splitViewer()
            if (firstLoad === true) {
                viewerFlyTo(datasetConf)
                firstLoad = false
            }
        } else if (viewType === '1') {
            loadTileSet(dataset, dateStart, token, viewer, "tileSet", Cesium.SplitDirection.NONE)
                if (firstLoad === true) {
                    viewerFlyTo(datasetConf)
                    firstLoad = false
                }
        }
    }
    createViewer(dataset, firstLoad,  leftDate, rightDate, viewType)



}

export default ThreeDViewComponent
